/* =========================
   MOBILE MENU TOGGLE
========================= */

const toggle = document.querySelector(".menu-toggle");
const navbar = document.querySelector(".navbar");

if (toggle && navbar) {
    const icon = toggle.querySelector("i");

    toggle.addEventListener("click", () => {
        navbar.classList.toggle("active");

        if (icon) {
            icon.classList.toggle("fa-bars");
            icon.classList.toggle("fa-xmark");
        }

        if (!navbar.classList.contains("active")) {
            document.querySelectorAll(".menu-item.active").forEach(item => {
                item.classList.remove("active");
            });
        }
    });
}


/* =========================
   MOBILE SUB MENU TOGGLE
========================= */

document.querySelectorAll(".menu-item > a").forEach(link => {

    link.addEventListener("click", function (e) {

        if (window.innerWidth > 1200) return;

        const parent = this.parentElement;

        const submenu = parent.querySelector(
            ":scope > .mega-menu, :scope > .dropdown"
        );

        if (!submenu) return;
 
        e.preventDefault();

        parent.parentElement
            .querySelectorAll(":scope > .menu-item.active")
            .forEach(item => {

                if (item !== parent) {
                    item.classList.remove("active");
                }

            });

        parent.classList.toggle("active");

    });

});


/* =========================
   RESET ON RESIZE
========================= */

window.addEventListener("resize", () => {

    if (window.innerWidth > 1200) {

        navbar.classList.remove("active");

        document.querySelectorAll(".menu-item.active").forEach(item => {
            item.classList.remove("active");
        });

    }

});


// $(document).ready(function () {
//     $('.search-toggle').click(function (e) {
//         e.preventDefault();

//         const $toggle = $(this);
//         const $search = $('.header_search');
//         const $icon = $toggle.find('i');

//         // Toggle search box
//         $search.slideToggle(300).toggleClass('active');

//         // Toggle active class on button
//         $toggle.toggleClass('active');

//         // Toggle icon
//         if ($icon.hasClass('fa-search')) {
//             $icon.removeClass('fa-search').addClass('fa-times');
//         } else {
//             $icon.removeClass('fa-times').addClass('fa-search');
//         }
//     });
// });


/* =========================
   STICKY HEADER
========================= */

window.addEventListener("scroll", () => {
    const header = document.querySelector(".custom-header-new");
    if (header) {
        if (window.scrollY > 10) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }
});


const marquees = document.querySelectorAll(".topbar_left ul");
marquees.forEach((marquee, index) => {
    marquee.innerHTML += marquee.innerHTML;
    let position = 0;
    const speed = 1;
    // even = left, odd = right
    const direction = index % 2 === 0 ? -1 : 1;
    function animateMarquee() {
        position += speed * direction;
        if (direction === -1 && Math.abs(position) >= marquee.scrollWidth / 2) {
            position = 0;
        }
        if (direction === 1 && position >= 0) {
            position = -marquee.scrollWidth / 2;
        }
        marquee.style.transform = `translateX(${position}px)`;
        requestAnimationFrame(animateMarquee);
    }
    // start right-moving marquee from left side
    if (direction === 1) {
        position = -marquee.scrollWidth / 2;
    }
    animateMarquee();
});



/* =========================
    Contact Section Image Slider
========================= */
$('.contact-slider').owlCarousel({
    items: 1,
    loop: true,
    autoplay: true,
    autoplayTimeout: 4000,
    autoplaySpeed: 1800,
    smartSpeed: 1800,
    dots: false,
    nav: false,
    animateOut: 'fadeOut',
    animateIn: 'fadeIn',
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    freeDrag: false
})

// Product slider 
$(document).ready(function () {
    $(".product_carousel").owlCarousel({
        loop: true,
        margin: 32,
        stagePadding: 3,
        nav: false,
        dots: false,
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1
            },
            575: {
                items: 2
            },
            880: {
                items: 3
            },
            1200: {
                items: 4
            },
            1280: {
                items: 5
            }
        }
    });
});

$(document).ready(function () {
    var counted = 0;

    $(window).scroll(function () {
        var $counter = $('#counter');

        if ($counter.length > 0) { // Check if #counter element exists
            var oTop = $counter.offset().top - window.innerHeight;

            if (counted === 0 && $(window).scrollTop() > oTop) {
                $('.count').each(function () {
                    var $this = $(this),
                        countTo = $this.attr('data-count');

                    $({ countNum: $this.text() }).animate({
                        countNum: countTo
                    },
                        {
                            duration: 4000,
                            easing: 'swing',
                            step: function () {
                                $this.text(Math.floor(this.countNum));
                            },
                            complete: function () {
                                $this.text(this.countNum);
                            }
                        });
                });
                counted = 1;
            }
        }
    });
});


const video = document.getElementById("myVideo");
const btn = document.getElementById("videoBtn");

function toggleVideo() {
    if (video) {
        if (video.paused) {
            video.play();
        } else {
            video.pause();
        }
    }
}

if (video && btn) {
    // Hide button when playing
    video.addEventListener("play", function () {
        btn.classList.add("hide");
    });

    // Show button when paused
    video.addEventListener("pause", function () {
        btn.classList.remove("hide");
    });

    // Show button when video ends
    video.addEventListener("ended", function () {
        btn.classList.remove("hide");
    });
}



$(document).ready(function () {
    // $(".productimage__carousel").owlCarousel({
    //     loop: true,
    //     margin: 18,
    //     items: 3,
    //     stagePadding: 10,
    //     touchDrag: false,
    //     mouseDrag: false,
    //     nav: true,
    //     dots: false,
    //     autoplay: false,
    //     autoplayTimeout: 3000,
    //     navText: [
    //         '<div class="position-relative overflow-hidden"><img src="https://cdn.shopify.com/s/files/1/0049/4125/0646/files/arrow-left-side.svg" alt="Previous"></div>',
    //         '<div class="position-relative overflow-hidden"><img src="https://cdn.shopify.com/s/files/1/0049/4125/0646/files/arrow-right-side.svg" alt="Next"> </div>'
    //     ],
    //     responsive: {
    //         0: {
    //             items: 1
    //         },
    //         575: {
    //             items: 2
    //         },
    //         991: {
    //             slideBy: 1,
    //             autoWidth: true,
    //             items: 2
    //         },
    //         1300: {
    //             autoWidth: true,
    //             slideBy: 1,
    //             items: 2
    //         },
    //         1800: {
    //             autoWidth: true,
    //             slideBy: 3,
    //             items: 3,
    //         },
    //     }
    // });


    $(".productimage__carousel").owlCarousel({
        loop: true,
        margin: 25,
        items: 3,
        stagePadding: 10,
        touchDrag: false,
        mouseDrag: false,
        nav: true,
        dots: false,
        autoplay: false,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        navText: [
            '<div class="position-relative overflow-hidden"><img src="https://cdn.shopify.com/s/files/1/0049/4125/0646/files/arrow-left-side.svg" alt="Previous"> <img src="https://cdn.shopify.com/s/files/1/0049/4125/0646/files/arrow-left-side.svg" alt="Previous"></div>',
            '<div class="position-relative overflow-hidden"><img src="https://cdn.shopify.com/s/files/1/0049/4125/0646/files/arrow-right-side.svg" alt="Next"> <img src="https://cdn.shopify.com/s/files/1/0049/4125/0646/files/arrow-right-side.svg" alt="Next"> </div>'
        ],
        responsive: {
            0: {
                items: 1
            },
            575: {
                items: 2
            },
            991: {
                slideBy: 2,
                autoWidth: false,
                items: 3
            },
            1300: {
                autoWidth: true,
                slideBy: 1,
                items: 3
            },
            1800: {
                autoWidth: true,
                slideBy: 3,
                items: 3,
            },
        }
    });


});


document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('[id^="productTabs-"]').forEach(tabContainer => {

        const tabs = tabContainer.querySelectorAll(".nav-link");
        const slider = tabContainer.querySelector(".slider");

        function moveSlider(tab) {
            slider.style.width = tab.offsetWidth + "px";
            slider.style.left = tab.offsetLeft + "px";
        }

        const activeTab = tabContainer.querySelector(".nav-link.active");
        if (activeTab) moveSlider(activeTab);

        tabs.forEach(tab => {
            tab.addEventListener("shown.bs.tab", function () {
                moveSlider(this);
            });
        });

    });

});